export type { M70MediaProps } from './M70Media';
export { M70Media } from './M70Media';
export { M70Media as default } from './M70Media';
